import { baseSocketURL } from "configs/axiosConfig";
import React, { useEffect } from "react";
import MyRouter from "routers/index";
import io from "socket.io-client";
import AOS from "aos";
import "aos/dist/aos.css";

// const ENDPOINT = "https://socket-lokalai-23jul.onrender.com/";
// const ENDPOINT = "http://localhost:6005/";

const socketId = io(baseSocketURL, { transports: ["websocket"] });

function App() {
  useEffect(() => {
    localStorage.setItem("theme", "dark");
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 400, // Fast but still smooth (100 is too snappy)
      easing: "ease-out", // Quicker finish
      once: true, // Animate only once when in view
      offset: 80,
    });
  }, []);
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter socketId={socketId} />
    </div>
  );
}

export default App;
